export { hinnakalkulaator };

const hinnakalkulaator = () => {
    if (MODULE_NAME === "hinnakalkulaator") {
        var closeTimeout;
        var height = $(".content").height();
        $(".content-wrapper").css({
            minHeight: height
        });
        dataLayer.push({
            'event': 'GAEvent',
            'eventCategory': 'bannerikalkulaator',
            'eventAction': 'avamine'
        });
    
        $("a", $(".best-auctions-link")).on("click", function () {
            $(".best-auctions-link").hide();
            $(".best-auctions-content").slideDown("slow");
    
            dataLayer.push({
                'event': 'GAEvent',
                'eventCategory': 'Calculator',
                'eventAction': 'viewAuctions'
            });
            return false;
        });
        $("a", $(".best-auctions-link")).on("mouseenter", function () {
            $(".best-auctions-link").hide();
            $(".best-auctions-content").slideDown("slow");
    
            dataLayer.push({
                'event': 'GAEvent',
                'eventCategory': 'Calculator',
                'eventAction': 'viewAuctions'
            });
        });
        $(".best-auctions-content").on("mouseenter", function () {
            if (closeTimeout) {
                clearTimeout(closeTimeout);
                closeTimeout = false;
            }
        });
        $(".best-auctions-content").on("mouseleave", function () {
            if (closeTimeout) {
                clearTimeout(closeTimeout);
            }
            var $this = $(this);
            closeTimeout = setTimeout(function () {
                $this.slideUp("slow", function () {
                    $(".best-auctions-link").show();
                });
            }, 500);
        });
        $(".close", $(".best-auctions-content")).on("click", function () {
            $(".best-auctions-content").slideUp("slow", function () {
                $(".best-auctions-link").show();
            });
            return false;
        });
    }
}